import _ from "lodash";

export function buildSortedDataSourceEntries(teamsHandles, trendsHandles) {
    const teamsItems = teamsHandles || [];
    const linkedTrendsIds = new Set(
        teamsItems
            .filter((handle) => handle.trendsId)
            .map((handle) => handle.trendsId)
    );

    const findTrendsHandle = (handle) => {
        if (!handle.trendsId || _.isEmpty(trendsHandles)) {
            return null;
        }
        return trendsHandles.find((trendsHandle) => trendsHandle.id === handle.trendsId) || null;
    };

    const teamsEntries = teamsItems.map((handle) => ({
        key: handle.id,
        isTrendsOnly: false,
        handle,
        trendsHandle: findTrendsHandle(handle),
    }));

    const trendsOnlyEntries = (trendsHandles || [])
        .filter((trendsHandle) => !linkedTrendsIds.has(trendsHandle.id))
        .map((trendsHandle) => ({
            key: `trends-${trendsHandle.id}`,
            isTrendsOnly: true,
            handle: null,
            trendsHandle,
        }));

    return _.sortBy(
        [...teamsEntries, ...trendsOnlyEntries],
        (entry) => (entry.isTrendsOnly ? entry.trendsHandle.name : entry.handle.name)?.toLowerCase() || ''
    );
}
